module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b246d0b191ec6afb48f0989335ce47d0.png";